import React, { useState } from 'react';

const PosterAndVideo = ({ posterImage, videoSrc }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className="ptp-splash-page__how-it-works-video-container">
      {!isPlaying ? (
        <div
          className="ptp-splash-page__how-it-works-video-poster"
          onClick={handlePlay}
        >
          <div className="ptp-splash-page__play-button">&#9658;</div>
          <img
            data-testid="how-it-works-video-poster"
            className="ptp-splash-page__how-it-works-video-frame"
            src={posterImage}
            alt="Frame of Path to pro video"
          />
        </div>
      ) : (
        <video
          className="ptp-splash-page__video"
          controls
          controlsList="nodownload"
          poster="https://assets.thdstatic.com/images/v1/path-to-pro/HIW-1.png"
          autoPlay
        >
          <source
            src={videoSrc}
            type="video/webm"
            data-testid="how-it-works-video"
          />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default PosterAndVideo;
